module.exports = __webpack_public_path__ + "img/roadbase-icon.e69104fc.jpg";